import { useMemo } from "react";
import Video from "./Video";
import { generatePageNumbers } from "../../util/generatePageNumber";
import LoadingSpinner from "../../components/loader/Loader";

const PaginatedVideosGrid = ({
  videos = [],
  currentPage,
  totalPages,
  activeVideoId,
  source = "videoList",
  navigate,
  isLoading,
}) => {
  const pageNumbers = useMemo(
    () => generatePageNumbers(currentPage, totalPages),
    [currentPage, totalPages]
  );

  if (isLoading) return <LoadingSpinner />;

  if (!videos || videos.length === 0) {
    return (
      <div className="not">
        No videos found.
      </div>
    );
  }

  const handlePageClick = (page) => {
    // Update URL instead of local state
    const params = new URLSearchParams(window.location.search);
    params.set("page", page);
    navigate({ search: params.toString() });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="video-grid">
        {videos.map((video) => {
          const videoUrl = `/watch/${video.slug || video._id}`;
          return (
            <Video
              key={video._id}
              video={video}
              videos={videos}
              currentPage={currentPage}
              isActive={video._id === activeVideoId}
              onClick={() => {
                const params = new URLSearchParams(window.location.search);
                // navigate will use the current URL params automatically if not specified
                // to explicitly carry the page param, pass the search string
                navigate(`${videoUrl}?${params.toString()}`, {
                  state: { source, page: currentPage },
                });
              }}
              variant="grid"
            />
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="pagination responsive-pagination">
          <button
            onClick={() => handlePageClick(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1}
          >
            {"<"}
          </button>
          {pageNumbers.map((page, idx) =>
            page === "..." ? (
              <span className="ellipsis" key={idx}>
                ...
              </span>
            ) : (
              <button
                key={idx}
                className={currentPage === page ? "active" : ""}
                onClick={() => handlePageClick(page)}
              >
                {page}
              </button>
            )
          )}
          <button
            onClick={() =>
              handlePageClick(Math.min(currentPage + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            {">"}
          </button>
        </div>
      )}
    </div>
  );
};

export default PaginatedVideosGrid;
